import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import AuthForm from '@/components/authForm/AuthForm';
import FullscreenBackground from '@/components/image/FullscreenBackground';
import Loader from '@/components/Loader';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useAppLoadedState } from '@/hooks/store';
import genericMessages from '@/messages/messages';
import getUrl from '@/utils/getUrl';

import Image from '../image/NextImage';
import StripeElementsProvider from '../purchase/StripeElementsProvider';
import Carousel from './Carousel';
import HowToUse from './HowToUse';
import messages from './messages';
import PaymentForm from './PaymentForm';
import Ratings from './Ratings';
import {
	FormContainer,
	Heading,
	HeroMask,
	HeroRow,
	HeroSection,
	LeftColumn,
	LoginInner,
	LoginWrapper,
	Logos,
	RightColumn,
	Subheading,
	Subtitle,
	Title,
} from './styles';
import WhatYouGet from './WhatYouGet';

const TheDodo = () => {
	const appLoaded = useAppLoadedState();
	const { authPrompt } = useAuthPrompt();
	const { formatMessage } = useIntl();
	const [currentForm, setCurrentForm] = useState<'loading' | 'auth' | 'cc' | 'purchaseError'>('loading');
	const [email, setEmail] = useState('');

	useEffect(() => {
		if (appLoaded) {
			// TODO: refactor this code to follow best practices
			// eslint-disable-next-line react-hooks/set-state-in-effect
			setCurrentForm(email ? 'cc' : 'auth');
		}
	}, [appLoaded, email]);

	const slides = [
		{
			tileUrl: `${getUrl('www-app')}/player/zbwEhhdPpF`,
			tileImage: '/_n/images/thedodo/dodo_tile_frankie.webp',
			title: formatMessage(messages.augSlide1Title),
			description: formatMessage(messages.dodoSlide1Description),
		},
		{
			tileUrl: `${getUrl('www-app')}/player/KZRTnHsijc`,
			tileImage: '/_n/images/thedodo/dodo_tile_arnie.webp',
			title: formatMessage(messages.augSlide2Title),
			description: formatMessage(messages.dodoSlide2Description),
		},
	];

	return (
		<StripeElementsProvider isStripeNext>
			<HeroSection>
				<FullscreenBackground src="/_n/images/thedodo/dodo_background.webp" objectPosition="bottom" />
				<HeroRow>
					<LeftColumn>
						<Logos>
							<Image src="/_n/images/thedodo/dodo_logo.webp" alt="Calm's logo and TheDodo logo" fill />
						</Logos>
						<Title>{formatMessage(messages.headline)}</Title>
						<Subtitle>{formatMessage(messages.subHeadline)}</Subtitle>
					</LeftColumn>
					<RightColumn>
						<LoginWrapper id="login-signup">
							<LoginInner>
								<FormContainer>
									{currentForm === 'loading' && <Loader color="gray7" />}
									{currentForm === 'auth' && (
										<>
											<Heading>
												{formatMessage(
													authPrompt === 'signup' ? messages.loginTitle : genericMessages.loginTitle,
												)}
											</Heading>
											<Subheading>{formatMessage(messages.cardRequired)}</Subheading>
											<AuthForm
												onAuthSuccess={newUser => setEmail(newUser?.email || '')}
												initialValues={{ email }}
											/>
										</>
									)}
									{currentForm === 'cc' && <PaymentForm />}
								</FormContainer>
							</LoginInner>
						</LoginWrapper>
					</RightColumn>
				</HeroRow>
				<HeroMask />
			</HeroSection>
			<Carousel slides={slides} />
			<WhatYouGet />
			<HowToUse />
			<Ratings />
		</StripeElementsProvider>
	);
};

export default TheDodo;
